import type { PayerPlanType, PayerRow } from './types';

export const PAYER_PLAN_OPTIONS: { value: PayerPlanType; label: string }[] = [
  { value: 'commercial', label: 'Commercial' },
  { value: 'medicare', label: 'Medicare' },
  { value: 'medicare_advantage', label: 'Medicare Advantage' },
  { value: 'medicaid', label: 'Medicaid' },
  { value: 'managed_medicaid', label: 'Managed Medicaid' },
  { value: 'other', label: 'Other' },
];

/** Participation can suggest a plan only when there is exactly one recognized program. */
export function initialPayerPlanTypes(programs: PayerRow['programs']): PayerRow['planTypes'] {
  const uniquePrograms = [
    ...new Set((programs ?? []).map(program => program.trim().toLowerCase())),
  ];
  if (uniquePrograms.length !== 1) return null;
  const plan = PAYER_PLAN_OPTIONS.find(option => option.value === uniquePrograms[0]);
  return plan ? [plan.value] : null;
}

export function payerPlanLabel(plan: PayerPlanType): string {
  return PAYER_PLAN_OPTIONS.find(option => option.value === plan)?.label ?? plan;
}
